import { Button, Card, Header } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import createProductionTodo from "astrid-firestore/src/api/productions/todos/createProductionTodo";
import { ProductionTodo as ProductionTodoSchema } from "astrid-firestore/src/api/productions/types/ProductionTodo";

import Flex from "../../../../components/Flex/Flex";
import ErrorModal from "../../../ui/components/ErrorModal/ErrorModal";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

import ProductionTodo from "./components/ProductionTodo";

function createdAt(todo) {
	return todo.created?.toMillis() ?? Infinity;
}

export default function ProductionTodos({ production, todos }) {
	const { t } = useTranslation();
	const user = useProfile();

	const { form, onSubmit, formState, error } = useSimpleForm({
		schema: ProductionTodoSchema,
		defaultValues: {
			text: "",
		},
		clearOnSuccess: true,
		onSubmit: ({ text }) => {
			return createProductionTodo(firebase, {
				production,
				text,
				createdBy: user,
			});
		},
	});

	const sortedTodos = [...(todos || [])].sort((a, b) => createdAt(a) - createdAt(b) || 0);

	return (
		<>
			<Header as="h4">{t("todosBeforeDelivery", "Todo's before delivery")}</Header>

			<Card fluid>
				{sortedTodos.map((todo) => (
					<ProductionTodo key={todo.id} todo={todo} />
				))}

				<Card.Content>
					<Form form={form}>
						<Flex gap={5}>
							<div style={{ flex: 1 }}>
								<Form.Input name="text" style={{ flex: 1, marginBottom: 0 }} />
							</div>

							<Button onClick={onSubmit} disabled={formState.isSubmitting || !formState.isDirty}>
								{t("add", "Add")}
							</Button>
						</Flex>
					</Form>
				</Card.Content>
			</Card>

			{error && <ErrorModal error={error} />}
		</>
	);
}
